import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Gallery() {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const galleryImages = [
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/310057a4198c082ab1e3a4d0ce575f55.jpeg', titleKey: 'gallery_img_1' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/8d2c911684c88a1546a89f5a040590a1.jpeg', titleKey: 'gallery_img_2' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/72d3bdaf276430134968b8415f38f060.jpeg', titleKey: 'gallery_img_3' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/99b55c20ff8d6f1fcfaa93236076a3df.jpeg', titleKey: 'gallery_img_4' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/eb87fe8ababc9b80da7a992c54669790.jpeg', titleKey: 'gallery_img_5' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/a6c1aaa22ef77d8d716b6e4f07587808.jpeg', titleKey: 'gallery_img_6' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/2ef145cac7a82ddee5cb1230672a2026.jpeg', titleKey: 'gallery_img_7' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/4ee79a56daffedec99445481b7414675.jpeg', titleKey: 'gallery_img_8' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/e27c702ea22fae2a3a6726c34aaf3d06.jpeg', titleKey: 'gallery_img_9' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/c9faa49992a13e75092b6ad16ae1ca53.jpeg', titleKey: 'gallery_img_10' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/56e0b17677eab3e27474b6fa075e7a10.jpeg', titleKey: 'gallery_img_11' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/6545e1253afde6f8deba9923b25891f4.jpeg', titleKey: 'gallery_img_12' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/426bc0cdf081332902a4f007e5b8a679.jpeg', titleKey: 'gallery_img_13' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/f18a6b3ae6981d51dedc03fbd44b3a6e.jpeg', titleKey: 'gallery_img_14' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/d60bf78243c431ba3bf39c025123251b.jpeg', titleKey: 'gallery_img_15' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/b806099a390b4dd44d4dd6987f3a4053.jpeg', titleKey: 'gallery_img_16' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/b48f14135564f9ace5df79a46ea78d35.jpeg', titleKey: 'gallery_img_17' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/4b6f995aeb7fbf069021f9e026858c55.jpeg', titleKey: 'gallery_img_18' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/f15ef0d5cd2c33310c76c54b78939a38.jpeg', titleKey: 'gallery_img_19' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/55c6464b3636053e74bd19f15b33927c.jpeg', titleKey: 'gallery_img_20' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/de225157dd5c99ee6ce217528c57eb28.jpeg', titleKey: 'gallery_img_21' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/3d914c8fe9590a931d67ead9c0bc6160.jpeg', titleKey: 'gallery_img_22' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/482750d90c2121e68c046bdf1c0a4e2b.jpeg', titleKey: 'gallery_img_23' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/1d67c0b8a3d2021dfcb448a0246aff0c.jpeg', titleKey: 'gallery_img_24' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/e00708066695c02ad3086bdbd88661fb.jpeg', titleKey: 'gallery_img_25' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/53ec10ed9e2a0ee608b4b3276d48887e.jpeg', titleKey: 'gallery_img_26' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/a704d1a9a5e22abe9251f43c9bb88463.jpeg', titleKey: 'gallery_img_27' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/cfde5fde8beaf12c249f419dab450cb6.jpeg', titleKey: 'gallery_img_28' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/67b59bde87f9014620a85a087381a4d6.jpeg', titleKey: 'gallery_img_29' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/c7ac1e9188e91139f595501a1e148719.jpeg', titleKey: 'gallery_img_30' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/4b7e3042a36ea5b85b1c082097baa549.jpeg', titleKey: 'gallery_img_31' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/5866d6cfbd34b582d8541eb8d157dcdb.jpeg', titleKey: 'gallery_img_32' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/42363979b3c4eb9463b3e81f35a3a785.jpeg', titleKey: 'gallery_img_33' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/f778a4e08eb3e1ea387f8927526832ce.jpeg', titleKey: 'gallery_img_34' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/224f1bb6f8f79a528839658cbd120516.jpeg', titleKey: 'gallery_img_35' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/d6cbba612de444f48f4b85f6485bf50d.jpeg', titleKey: 'gallery_img_36' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/48aeac18811f5303fe731952a7d7766d.jpeg', titleKey: 'gallery_img_37' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/6580c76c681eed77d292f9f397173a7b.jpeg', titleKey: 'gallery_img_38' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/4922baebb57f1fc62e9a3ef75a7ed418.jpeg', titleKey: 'gallery_img_39' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/1420dd63decab0c4448edf45a5ff3261.jpeg', titleKey: 'gallery_img_40' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/c5e0f0bf71bd4f540cd9e047660895db.jpeg', titleKey: 'gallery_img_41' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/8e5a9a0a4aadffae7c539cb04673cdfb.jpeg', titleKey: 'gallery_img_42' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/953b32eb8fca8cb20a113c021056f30e.jpeg', titleKey: 'gallery_img_43' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/97d4718e90ba79ce3a6f3a7cb2aff639.jpeg', titleKey: 'gallery_img_44' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/3cfa8e0b38f1d5b732cd72f5571275d4.jpeg', titleKey: 'gallery_img_45' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/2bcbee4db10abc181add13cc3d6c14fd.jpeg', titleKey: 'gallery_img_46' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/9963b450e38bdb65c85e5d9fe64ef1a6.jpeg', titleKey: 'gallery_img_47' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/a4923526c2b68b5acbb6d6d7d73d25f4.jpeg', titleKey: 'gallery_img_48' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/902f5292afc13402e798b05df167bd25.jpeg', titleKey: 'gallery_img_49' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/48fa7ccaa795350c1822f51ec109681f.jpeg', titleKey: 'gallery_img_50' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/4adff7fec52c6cecae298d3593264dba.jpeg', titleKey: 'gallery_img_51' },
    { url: 'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/7d186f92a2310fc7bf4f0513c206f133.jpeg', titleKey: 'gallery_img_52' }
  ];

  const handlePrevious = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImage !== null) {
      setSelectedImage((prev) => (prev! - 1 + galleryImages.length) % galleryImages.length);
    }
  };

  const handleNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImage !== null) {
      setSelectedImage((prev) => (prev! + 1) % galleryImages.length);
    }
  };

  const handleClose = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    setSelectedImage(null);
  };

  return (
    <section className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-center mb-16 text-gray-900">
          {t('gallery_title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              onClick={() => setSelectedImage(index)}
              className="relative group overflow-hidden rounded-xl cursor-pointer shadow-md hover:shadow-2xl transition-all duration-300"
            >
              <img
                src={image.url}
                alt={t(image.titleKey)}
                className="w-full h-80 object-contain md:object-cover md:object-top transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <p className="text-white text-sm md:text-base font-medium p-4 w-full">
                  {t(image.titleKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage !== null && (
        <div
          onClick={handleClose}
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 cursor-pointer"
        >
          <button
            onClick={handleClose}
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer z-10"
            aria-label="Close gallery"
          >
            <i className="ri-close-line text-white text-3xl"></i>
          </button>

          <button
            onClick={handlePrevious}
            className="absolute left-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer z-10"
            aria-label="Previous image"
          >
            <i className="ri-arrow-left-s-line text-white text-3xl"></i>
          </button>

          <button
            onClick={handleNext}
            className="absolute right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer z-10"
            aria-label="Next image"
          >
            <i className="ri-arrow-right-s-line text-white text-3xl"></i>
          </button>

          <div 
            className="max-w-6xl w-full" 
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={galleryImages[selectedImage].url}
              alt={t(galleryImages[selectedImage].titleKey)}
              className="w-full h-auto max-h-[85vh] object-contain"
            />
            <p className="text-white text-center mt-6 text-xl md:text-2xl lg:text-3xl font-light">
              {t(galleryImages[selectedImage].titleKey)}
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
